import React, { useEffect } from 'react';
import Layout from './layouts/Layout';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import TelegramLoginButtonComponent from './components/TelegramLoginButton';
import './App.css';

function App() {
  useEffect(()=>{
    
  },[]);  
  return (
        <Layout>
           <Helmet>
                <title>ပွဲစားကြီး Pay</title>
          </Helmet>
          <div className="app-container">
            <div style={{textAlign:"center", marginBottom: "20px"}}>
              <TelegramLoginButtonComponent />
            </div>
            
            <div className="welcome-section">
              <h6>မင်္ဂလာပါ {localStorage.getItem('name')} 👋</h6>
              <p>ပွဲစားကြီး Pay မှကြိုဆိုပါတယ်</p>
              <div className="vpn-notice">
                ⚡ VPN ဖွင့်ထားပြီး အသုံးပြုပါ
              </div>
            </div>

            <div className="service-grid">
              <div className="service-card">
                <Link to={"/won-to-kyat"} className='link'>
                  <img src="won_to_kyat.png" className="service-image" alt='Won to Kyat'></img>
                </Link>
                <p className="service-label">ဝမ်ပေးကျပ်ယူ</p>
              </div>
              <div className="service-card">
                <Link to={"/kyat-to-won"} className='link'>
                  <img src="kyat_to_won.png" className="service-image" alt='Kyat to Won'></img>
                </Link>
                <p className="service-label">ကျပ်ပေးဝမ်ယူ</p>
              </div> 
              <div className="service-card">
                <Link to={"/won-to-kyat-form/6"} className='link'>
                  <img src="bath_to_kyat.png" className="service-image" alt='Bath to Kyat'></img>
                </Link>
                <p className="service-label">ဘတ်တင်ပေး</p>
              </div> 
            </div>

            <div className="contact-section">
              <h6>📞 ဆက်သွယ်ရန်</h6>
              <div className="contact-item">
                <span className="contact-number">01073481563</span>
                <a href="tel:01073481563" className="contact-btn">
                  <i className="lni lni-phone"></i> Call
                </a>
              </div>
              <div className="contact-item">
                <span className="contact-number">01073481563</span>
                <a href="https://telegram.me/+821073481563" target="_blank" className="contact-btn" rel="noopener noreferrer">
                  <i className="lni lni-phone"></i> Telegram
                </a>
              </div>
            </div>
          </div>
        </Layout>
  );
}

export default App;
